<template>
<!-- 分享审核 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <el-form class="findform">
        <el-form-item label="提交时间：" style="width:30%">
          <el-date-picker type="daterange" v-model="tijiaoTime" unlink-panels @change="changeTimeTj" style="width:80%"
            range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item label="审核时间：" style="width:30%">
          <el-date-picker type="daterange" v-model="shTime" unlink-panels @change="changeTimeSh" style="width:80%"
            range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item label="状态：" style="display:flex;width:30%">
          <el-select v-model="ztid" placeholder="请选择" ref="mySelect" style="width:80%">
            <el-option v-for="(item,index) in zhuangtai" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <section class="model_section">
      <el-col :span="18" style>
        <p class="model_top_title">分享审核</p>
      </el-col>
    </section>
    <div class="table_container">
      <el-table :data="dataList" class="invoice_tab" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="分享内容" align="center">
          <template scope="scope"><span class="spanList">{{ scope.row.taskname }}</span></template>
        </el-table-column>
        <el-table-column label="分享类型" align="center" width="160px">
          <template scope="scope">{{scope.row.tasktypename}}</template>
        </el-table-column>
        <el-table-column label="奖金（元）" align="center" width="100px">
          <template scope="scope">￥{{scope.row.bonus}}</template>
        </el-table-column>
        <el-table-column label="提交时间" align="center" width="180px">
          <template scope="scope">{{scope.row.submittime}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100px">
          <template scope="scope">{{scope.row.statusname}}</template>
        </el-table-column>
        <el-table-column label="操作人" align="center" width="120px">
          <template scope="scope">{{scope.row.operatorname}}</template>
        </el-table-column>
        <el-table-column label="操作时间" align="center" width="180px">
          <template scope="scope">{{scope.row.audittime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160px">
          <template scope="scope">
            <span @click="seeOrder(scope.row, 1)" class="handle" v-show="scope.row.status != 1"> <i class="el-icon-view"></i> 查看 </span>
            <span @click="seeOrder(scope.row, 2)" class="handle" v-show="scope.row.status == 1"> <i class="el-icon-s-check"></i> 审核 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="initTotal" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="detailsDialog">
    <template v-slot:title>
      <span class="drawer_title">详情</span>
    </template>
    <div style="width: 90%; margin: 0 auto;">
      <div style="border-bottom: 2px solid #eee; margin-bottom: 10px;padding-top: 10px;">
        <b>任务信息</b>
        <p><span>分享内容：</span> <span>{{formDetails.taskname}}</span></p>
        <p><span>分享类型：</span> <span>{{formDetails.tasktypename}}</span></p>
        <p><span>分享文案：</span> <span>{{formDetails.remark}}</span></p>
        <p><span>截止日期：</span> <span>{{formDetails.enddate}}</span></p>
        <p><span>任务奖励：</span> <span style="color: #3BB575;">￥{{formDetails.bonus}}元</span></p>
        <p>
          <span>任务规则：</span>
          <span style="display: inline-table;">
          <ul v-for="item in formDetails.rules" :key="item">
            <li style="line-height: 25px;">{{item.sort}}.{{item.taskdesc}};</li>
          </ul>
          </span>
        </p>
      </div>
      <div>
        <b>任务进度</b>
        <ul style="width: 100%; margin: 0 auto;">
          <li class="rwjdList" v-for="(item, index) in formDetails.progress" :key="index">
            <!-- 模拟步骤条的节点，此处为圆圈 -->
            <!-- <div :class="item.status >= index+1 ? 'roundIcon roundActive':'roundIcon'"></div> -->
            <div :class="index==0 ? 'roundIcon roundActive':'roundIcon'"></div>
            <!-- 模拟步骤条连接线，动态显示  -->
            <div :class="item.status >= index+2 ? 'jdt lineActive':'jdt'" v-show="index!==formDetails.progress.length-1"></div>
            <!-- <p style="color: #999;margin-left: 20px;">{{item.createtime | filTime}}</p> -->
            <p style="color: #999;margin-left: 20px;">{{item.createtime}}</p>
            <p style="margin-left: 20px;" :class="item.isfail==1?'redClass':''">{{item.progressname}} <span v-show="item.remark">：{{item.remark}}</span></p>
            <ul class="videoandpic" v-show="item.status==1">
              <li v-for="(item, index) in processedData" :key="index">
                <el-image :src="item.videoimgFullUrl" @click="handleClickItem" :preview-src-list="[item.videoimgFullUrl]"
                style="width: 80px;height: 80px;"/>
                <div class="trans" v-show="item.datatype == 2" @click="palySeevideo(item)">
                  <img src="../../assets/img/play.png" class="mengceng"/>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="drawer_foot">
        <el-button type="warning" @click="careful(3)" v-show="stateType==2">不通过</el-button>
        <el-button type="primary" @click="careful(2)" v-show="stateType==2">审核通过</el-button>
        <el-button type="primary" @click="detailsDialog = false" v-show="stateType==1">返回</el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 审核通过 & 不通过 -->
  <el-dialog title="审核不通过" :visible.sync="seeTksh" :center="true" class="add_order_cancle" width="25%">
    <el-form>
      <el-form-item label="不通过理由：" style="display:flex;">
        <el-select v-model="shenmark" placeholder="请选择" style="background:#fff;width:100%" ref="mySelect">
          <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.dDicId" :label="item.dDicName"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button @click="qdTksh()" type="danger">确定</el-button>
      <el-button @click="seeTksh = false">取 消</el-button>
    </div>
  </el-dialog>

  <!-- 视频播放 -->
  <el-dialog title="视频播放" :visible.sync="videoVisible" @close="closeDialog" width="35%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, datadictionaryGetlist } from "../../api/newOss";
import { postauditlist, postdetail, postprogress } from "../../api/comment";
export default {
  name: 'shareReview',
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      baseOssUrl: localStorage.BaseOssUrl,
      dialogVisibleadd: false,
      bbid:'',  //店铺id
      options1: [],

      dataList: [], // 查询列表
      pageIndex: 1,
      initTotal: 0,

      tijiaoTime: '', // 提交时间
      ksDate1: '', // 提交-开始时间
      jsDate1: '', // 提交-结束时间
      
      shTime: '', // 审核时间
      ksDate2: '', // 审核-开始时间
      jsDate2: '', // 审核-结束时间

      ztid: 0, // 状态
      zhuangtai: [ // 任务状态 0=全部 1=已提交 2=审核通过 3=审核不通过 4=申诉中 5=申诉通过 6=申诉不通过 7=打款完成
        {
          Id: 0,
          Name: "全部"
        },{
          Id: 1,
          Name: "待审核"
        },{
          Id: 2,
          Name: "审核通过"
        },{
          Id: 3,
          Name: "审核不通过"
        },{
          Id: 4,
          Name: "申诉中"
        },{
          Id: 5,
          Name: "申诉通过"
        },{
          Id: 6,
          Name: "申诉不通过"
        }
      ],

      shareid: '', // 用户ID
      taskid: '', // 任务ID
      taskType: '', // 任务状态
      stateType: 1, // 1查看 2审核
      detailsDialog: false, // 抽屉详情
      formDetails: {}, // 任务信息
      seeTksh: false, // 审核弹框
      shenmark: 0, // 不通过理由
      statusoptions: [], // 不通过理由
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },

    }
  },
  filters:{
    filTime(times) {
      return times.split('T').join(' ')
    },
  },
  computed: {
    processedData() {
      return this.formDetails.data.map(item => ({
        ...item,
        videoimgFullUrl: this.baseOssUrl + item.videoimg,
        datapathFullUrl: this.baseOssUrl + item.datapath,
      }));
    },
  },
  methods: {
    // 查询列表
    init() {
      let addParams = {
        shopid: this.bbid, // 店铺id
        submit_b_time: this.ksDate1, // 提交-开始时间
        submit_e_time: this.jsDate1, // 提交-结束时间
        audit_b_time: this.ksDate2, // 审核-开始时间
        audit_e_time: this.jsDate2, // 审核-结束时间
        status: this.ztid, // 状态
        pageindex: this.pageIndex, // 分页数据 当前页码
        pagesize: 10, // 分页数据 每页显示条数
      };
      postauditlist(addParams).then(data => {
        this.dataList = data.resultObj.list;
        this.initTotal = data.resultObj.totalcount;
      }).catch(err => {
        this.dataList = [];
        this.initTotal=0;
      });
    },
    // 查看 & 审核
    seeOrder(row, stateType) {
      this.shareid = row.userid; // 用户ID
      this.taskid = row.taskid; // 任务ID
      this.stateType = stateType; // 1查看 2审核
      this.detailsDialog = true;
      var addParams = {
        userid: this.shareid, // 用户ID
        taskid: this.taskid, // 任务ID
      };
      postdetail(addParams).then(data => {
        this.formDetails = data.resultObj;
      })
    },
    // 2审核通过 & 3不通过
    careful(valType) {
      this.taskType = valType; // 状态
      if(this.taskType == 2) {
        this.getprogress();
      }
      if(this.taskType == 3) {
        this.seeTksh = true; // 审核弹框
        this.shenmark = ''; // 不通过理由
        this.getorderstatus(); // 获取不通过理由
      }
    },
    // 二次确定
    qdTksh() {
      if(this.shenmark == "") {
        this.showAlert('请选择不通过理由');
        return false;
      }
      this.getprogress();
    },
    // 更新任务状态
    getprogress(){
      let addParams = {
        userid: this.shareid, // 用户ID
        taskid: this.taskid, // 任务ID
        status: this.taskType, // 任务状态 0=已领取 1=已提交 2=审核通过 3=审核不通过 4=申诉中 5=申诉通过 6=申诉不通过 7=打款完成
        remark: this.shenmark, // 审核备注
        operatorid: localStorage.Id, // 操作人ID
      };
      postprogress(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.init();
          this.seeTksh = false; // 审核弹框隐藏
          this.detailsDialog = false; // 抽屉隐藏
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 播放视频
    palySeevideo(url){
      this.playerOptions.sources[0].src = url.datapathFullUrl;
      this.videoVisible = true;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause();
    },
    // 提交时间
    changeTimeTj() {
      if(this.tijiaoTime+""=="null"){
        this.tijiaoTime = ["",""]
      }
      this.ksDate1 = this.tijiaoTime[0];
      this.jsDate1 = this.tijiaoTime[1];
    },
    // 审核时间
    changeTimeSh() {
      if(this.shTime+""=="null"){
        this.shTime = ["",""]
      }
      this.ksDate2 = this.shTime[0];
      this.jsDate2 = this.shTime[1];
    },
    // 不通过理由
    getorderstatus() {
      let obj = {
        code: 'task_audit_fail_reason',
      }
      datadictionaryGetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.statusoptions = data.resultObj;
        }
        if(data.resultCode == 4){
          this.statusoptions = [];
        }
      })
    },
    // 重置
    fnReset() {
      this.tijiaoTime = ''; // 提交
      this.ksDate1 = ''; // 提交-开始
      this.jsDate1 = ''; // 提交-结束
      this.shTime = ''; // 审核
      this.ksDate2 = ''; // 审核-开始
      this.jsDate2 = ''; // 审核-结束
      this.ztid = 0; // 状态
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 初始化查店铺
    getshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id;     //店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {      //默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.init(); // 查询列表
      this.dialogVisibleadd = false;
    },
  },
  created() {
    this.getshop(); // 初始化查店铺
  }
}
</script>
<style scoped>
/* 详情 */
.drawer_title {
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
/* 任务进度 */
.rwjdList{
  position: relative;
}
.roundIcon {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #ccc;
  position: absolute;
  top: 3px;
  z-index: 9;
}
.roundActive {
  background-color: #3BB575;
}
.jdt {
  width: 2px;
  height: 99%;
  background-color: #ccc;
  position: absolute;
  top: 17px;
  left: 5.2px;
}
/* .lineActive {
  background-color: #3BB575;
} */
/* 视频 & 图片 集合 */
.videoandpic {
  width: 92%;
  padding-left: 20px;
  position: relative;
  display: inline-block;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
  position: relative;
}
/* 使用半透明黑色作为蒙层颜色 */
.trans{
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.mengceng {
  width: 30px;
  position: absolute;
  left: 26px;
  top: 26px;
}
.redClass {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// shareReview.vue?27581cd0